export default "<small class=\"text-message-error\" id=\"text-message-error\">\n    {{ text }}\n</small>";